import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { AUTH_STATES, publicHash, SUCCESS } from '../../utils/constants';
import RegistrationInfoFrom from '../../components/RegistrationInfoForm/RegistrationInfoForm';

class RegistrationAddInfo extends Component {
  static isRegistrationAddInfo = true;
  static propTypes = {
    status: PropTypes.string.isRequired,
    error: PropTypes.string.isRequired,
    updateProfile: PropTypes.func.isRequired,
    email: PropTypes.string.isRequired,
    profile: PropTypes
      .shape({})
      .isRequired,
    annulUserError: PropTypes.func.isRequired,
    isAuthorized: PropTypes.bool.isRequired,
    getProfile: PropTypes.func.isRequired,
    logout: PropTypes.func.isRequired,
    getProfileStatus: PropTypes.func.isRequired,
    emailSubscriptions: PropTypes.shape({}).isRequired,
  }

  componentWillMount() {
    this.props.getProfile();
  }

  componentDidUpdate(prevProps) {
    const { status: prevStatus } = prevProps;
    const { status, getProfileStatus } = this.props;
    if (status !== prevStatus && status === SUCCESS) {
      getProfileStatus();
    }
  }

  componentWillUnmount() {
    if (document.location.pathname.indexOf('/app') === -1
      && document.location.pathname.indexOf('/auth/registration-info') === -1) {
      this.props.logout();
    }
  }

  submitHandler = (data) => {
    this.props.updateProfile(data);
  }

  renderComponent = ({
    status, error, email, annulUserError, profile, emailSubscriptions,
  }) => (
    <RegistrationInfoFrom
      status={status}
      ignoreFields={{ email: !!email }}
      submitHandler={this.submitHandler}
      error={error}
      initialFieldsState={profile}
      annulError={annulUserError}
      emailSubscriptions={emailSubscriptions}
    />
  )

  render() {
    const {
      status, error, email, annulUserError, profile, isAuthorized, emailSubscriptions,
    } = this.props;
    return isAuthorized === AUTH_STATES.DEAUTH ?
      <Redirect to={`${publicHash}/auth/registration`} />
      :
      this.renderComponent({
        status, error, email, annulUserError, profile, emailSubscriptions,
      });
  }
}

export default RegistrationAddInfo;



// WEBPACK FOOTER //
// ./src/containers/RegistrationAddInfo/RegistrationAddInfo.js